import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle } from '@angular/platform-browser';
import { RequestRoot } from 'types';
import { RequestViewTemplatesRegistry, ViewTemplateElement } from '../request-view-templates-registry';
import { RequestViewContentDirective } from './request-view-content-directive';

export interface Tile {
  content: SafeHtml;
  colsSpan: number;
  rowsSpan: number;
  classes: string[];
  style: SafeStyle;
}

@Component({
  selector: 'i-request-view',
  templateUrl: './request-view.component.html',
  styleUrls: ['./request-view.component.css'],
})
export class RequestViewComponent implements OnInit, AfterViewInit, OnChanges {
  gridColumnsCount: number;
  rows: Array<Array<Tile>> = [[]];
  @Input()
  templatekey: string | null = null;
  @Input()
  request: RequestRoot;
  @ViewChildren(RequestViewContentDirective)
  content: QueryList<any>;

  constructor(private _sanitizer: DomSanitizer, private _componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnChanges(changes: SimpleChanges): void {
    //this.ngOnInit();
    this.ngAfterViewInit();
  }

  ngOnInit() {
    if (this.templatekey) {
      const template = RequestViewTemplatesRegistry.getTemplate(this.templatekey);
      if (template) {
        const elems = template.elements.sort((a, b) => a.col + a.row * this.gridColumnsCount - (b.col + b.row * this.gridColumnsCount));
        this.gridColumnsCount = elems.reduce((pv, cv) => (cv.rightCol > pv.rightCol ? cv : pv)).rightCol;
        const gridRowsCount = Math.max(...elems.map((_) => _.row)) + 1;
        for (let ind = 0; ind < gridRowsCount; ++ind) {
          this.rows.push(elems.filter((_) => _.row === ind).map((_) => this.toTile(_, this.request, this.gridColumnsCount)));
        }
      }
    }
  }

  private toTile(el: ViewTemplateElement, request: RequestRoot, columnsCount: number): Tile {
    return {
      style: this._sanitizer.bypassSecurityTrustStyle(el.style + 'width: ' + Math.round(100 / columnsCount).toFixed() + '%;'),
      colsSpan: el.colSpan,
      rowsSpan: el.rowSpan,
      content: this._sanitizer.bypassSecurityTrustHtml(el.extractor(request)),
      classes: el.classes,
    };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.content
        .filter((_) => this.isSubRequestView(_.viewContainerRef))
        .map((_) => _.viewContainerRef)
        .forEach((viewContainerRef) => {
          const key = this.getSubRequestViewTemplateKey(viewContainerRef);
          viewContainerRef.clear();
          const componentFactory = this._componentFactoryResolver.resolveComponentFactory(RequestViewComponent);
          const componentRef = viewContainerRef.createComponent(componentFactory);
          (<RequestViewComponent>componentRef.instance).templatekey = key;
          (<RequestViewComponent>componentRef.instance).request = this.request;
        });
    });
  }

  private isSubRequestView(container: ViewContainerRef) {
    return container.element.nativeElement.innerHTML.includes('<i-request-view');
  }

  private getSubRequestViewTemplateKey(container: ViewContainerRef) {
    function substringBetween(str: string, b: string, e: string): string {
      return str.substring(str.lastIndexOf(b) + b.length, str.lastIndexOf(e));
    }
    const innerHtml = container.element.nativeElement.innerHTML;
    return substringBetween(innerHtml, 'templatekey="', '"');
  }
}
